















































































import { gsap } from "gsap";
import IconBase from "@/common/components/atoms/IconBase.vue";

import IconTile from "@/common/components/icons/IconTile.vue";
// import IconItemCategory from "@/common/components/icons/IconItemCategory.vue";
import InlineSvg from "vue-inline-svg";

import CategoryNaviItemLink from "@/common/components/organisms/header/general/CategoryNaviItemLink.vue";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

@Component({
  components: {
    IconBase,
    IconTile,
    // IconItemCategory,
    InlineSvg,
    CategoryNaviItemLink
  }
})
export default class TheHeaderNaviOfCategoryMenu extends Vue {
  // @Prop({ type: Array, required: true }) naviItem!: any;
  @Prop({ type: String, required: true }) iconColor!: string;
  @Prop({ type: Object, required: true }) pager!: any;
  @Prop({ type: Boolean, required: true }) shown!: boolean;
  @Prop({ type: Object, required: true }) dataOfPagerBeforeFormatting!: any;

  naviItem: Array<any> = [
    {
      label: "カテゴリー",
      url: false,
      children: [],
      ref: "categoryNavi"
    }
  ];

  get itemCategories() {
    return commons.itemCategories;
  }

  get internalShown() {
    return this.shown;
  }

  set internalShown(newValue) {
    if (newValue !== this.shown) {
      this.$emit("update:shown", newValue);
    }
  }

  get internalPager() {
    return this.pager;
  }

  set internalPager(newValue) {
    if (newValue !== this.pager) {
      this.$emit("update:pager", newValue);
    }
  }

  get internalDataOfPagerBeforeFormatting() {
    return this.dataOfPagerBeforeFormatting;
  }

  set internalDataOfPagerBeforeFormatting(newValue) {
    if (newValue !== this.dataOfPagerBeforeFormatting) {
      this.$emit("update:dataOfPagerBeforeFormatting", newValue);
    }
  }

  get parentItemObj() {
    return (children: any) => ({
      key: -1,
      children,
      refsName: "categoryNavi",
      pagerObj: {
        hierarchy: 1,
        text: "メインメニュー"
      }
    });
  }

  get childItemObj() {
    return (childKey: any, children: any, label: any) => ({
      key: childKey,
      children,
      refsName: "grandchildNavi",
      pagerObj: {
        hierarchy: 2,
        text: label
      }
    });
  }
  get grandChildItemObj() {
    return (grandchildKey: any) => ({
      key: grandchildKey,
      children: false,
      refsName: false,
      pagerObj: {
        text: false
      }
    });
  }

  @Watch("internalPager")
  onInternalPager() {
    this.startChildItemAnimation();
  }

  @Watch("itemCategories")
  onItemCategories() {
    this.naviItem[0].children = this.itemCategories;
  }

  // mounted() {
  //   this.creatNaviArray();
  // }

  // creatNaviArray() {
  //   const naviItem = this.naviItem;
  //   const itemCategories = this.itemCategories;
  //   let categoryArray = naviItem.map((value: any, index: any) => {
  //     if (value.children === "category") {
  //       return { value, index };
  //     }
  //     return {};
  //   });
  //   categoryArray = categoryArray.filter((v: any) => v);
  //   const resultCategoryArray = categoryArray[0].value;
  //   resultCategoryArray.children = itemCategories;
  // }

  emitChildItemObject(emitValue: any) {
    this.setChildItemObject(emitValue, true);
  }

  setChildItemObject(paramsObj: any, shown = true) {
    this.internalDataOfPagerBeforeFormatting = {
      paramsObj,
      shown
    };
  }

  initChildItemAnimation(shown: any) {
    const { refsName, key, oldRefsName, oldKey } = this.internalPager;
    const refs: any = this.$refs;
    const nextNavi = key < 0 ? refs[refsName] : refs[refsName][key];
    const width = 256 / 16;
    const speed = 0.12;
    let prevNavi: any;

    if (shown === false) {
      prevNavi = oldKey < 0 ? refs[oldRefsName] : refs[oldRefsName][oldKey];
    }

    this.$emit("animation-child-item", { speed, width, shown });

    const animationObj = {
      shown() {
        gsap.to(nextNavi, speed, {
          autoAlpha: 1,
          display: "block"
        });
      },

      hidden() {
        gsap.to(prevNavi, speed, {
          autoAlpha: 0,
          display: "none"
        });
      }
    };

    return animationObj;
  }

  startChildItemAnimation() {
    const { shown } = this;
    const animationObject = this.initChildItemAnimation(shown);

    if (shown) {
      animationObject.shown();
    } else {
      animationObject.hidden();
    }
  }
}
